<mat-form-field
  class="ccs-input-money {{ size }}"
  color="primary"
  [hideRequiredMarker]="true"
  [floatLabel]="floatLabel">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="text"
    [currencyMask]="{
      align,
      allowNegative,
      allowZero,
      decimal,
      precision,
      suffix,
      thousands,
      nullable,
      min,
      max,
      prefix,
      inputMode,
    }"
    [appCanAutoFocus]="autofocus"
    [maxlength]="maxLength"
    [formControl]="control"
    [placeholder]="placeholder"
    (focus)="onFocus.emit($event)"
    (blur)="onBlur.emit($event)"
    (keydown)="onKeydown.emit($event)"
    (keyup)="onKeyup.emit($event)"
    (input)="onInput.emit($any($event))" />

  @if (icon) {
    <button (click)="onEventClickIcon($event)" mat-icon-button matSuffix>
      <mat-icon [fontIcon]="icon" />
    </button>
  }

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  }

  <mat-error>
    {{ control.errors | errorMessage: errorMessages }}
  </mat-error>
</mat-form-field>
